import React from 'react';
import { Message } from 'talkplus-sdk/dist/model/types';
import styles from '@components/chat/chatDetail/messageList/index.module.scss';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

interface TimeProps {
  message: Message;
}

const Time = ({ message }: TimeProps) => {
  const time = DateFormat.formatAmPmText(new Date(message.createdAt));

  return <span className={cx('time')}>{time}</span>;
};

export default Time;
